module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-resumido-comitente sys-table"
  }, [_c('div', {
    staticClass: "chat-content"
  }, [_c('div', {
    staticClass: "message0 no-select"
  }, [_vm._v("\n      Nenhuma mensagem\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-588a0cc1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao-comitente/components/ChatResumidoComitente.vue
// module id = 1706
// module chunks = 17